export default __webpack_public_path__ + "static/media/safari-phone-1.c048a6a0.png";